import { useState } from "react";
import { Box, Button } from "@mui/material";
import { useTranslation } from "i18n-fe";

// #3479 - the ONE place a Review Queue row may show raw JSON or a raw error
// string. Closed by default and its children are not rendered at all until the
// admin opens it, so nothing technical is on screen (or findable by text)
// otherwise. Everything a show office admin reads sits outside it.
export default function TechnicalDetails({ children, testId = "technical-details" }) {
  const { t } = useTranslation("scoreadmin");
  const [open, setOpen] = useState(false);
  return (
    <Box sx={{ mt: 0.5 }}>
      <Button
        size="small"
        sx={{ px: 0, minWidth: 0 }}
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
        data-testid={`${testId}-toggle`}
      >
        {t(open ? "reviewQueue.technicalDetails.hide" : "reviewQueue.technicalDetails.show")}
      </Button>
      {open && (
        <Box sx={{ mt: 0.5 }} data-testid={`${testId}-panel`}>
          {children}
        </Box>
      )}
    </Box>
  );
}
